import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Box, IconButton, styled, alpha } from '@mui/material'

const Footer = styled('footer')(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: theme.spacing(3),
  transform: 'translateX(-50%)',
  padding: theme.spacing(0.8, 1),
  color: theme.palette.common.white,
  backgroundColor: alpha(theme.palette.common.black, 0.5),
  borderRadius: 50,
  userSelect: 'none',
}))

const Item = styled(Box)(({ theme }) => ({
  '& + &': {
    marginLeft: theme.spacing(5),
  },
}))

const Meta = styled('span')(({ theme }) => ({
  minWidth: theme.spacing(6),
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  textAlign: 'center',
}))

const ViewerFooter = ({ scale, onZoomInClick, onZoomOutClick }) => {
  return (
    <Footer>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Item display="flex" justifyContent="center" alignItems="center">
          <IconButton
            size="small"
            color="inherit"
            onClick={onZoomInClick}
            data-testid="plus-button"
          >
            <AddIcon />
          </IconButton>
          {scale && <Meta>{Math.round(scale * 100)}%</Meta>}
          <IconButton
            size="small"
            color="inherit"
            onClick={onZoomOutClick}
            data-testid="minus-button"
          >
            <RemoveIcon />
          </IconButton>
        </Item>
      </Box>
    </Footer>
  )
}

export default ViewerFooter
